import React from 'react'
import { TestSessionDetailWithResult_testSession_Products as Products } from '@modmd/data'
import Button from 'components/Button'
import { ConfirmationDialog } from 'components/Dialog'
import Datalist from 'components/Datalist'
import { COLOR, pxToRem, fontSizes } from 'theme'
import { Text } from 'components/Typography'
import { Box } from 'components/Layout'

interface Props {
  products: Products[]
  priceOfAllProducts: number
}

export const OrderedProductsInfo: React.VFC<Props> = ({ products, priceOfAllProducts }) => {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)

  return (
    <>
      <Button onClick={() => setIsDialogOpen(true)}>Show orders</Button>
      <ConfirmationDialog
        title="Ordered products"
        isOpen={isDialogOpen}
        onDismiss={() => setIsDialogOpen(false)}
        maxWidth={pxToRem(520)}
        actions={
          <>
            <Button onClick={() => setIsDialogOpen(false)} colorVariant="secondary">
              Close
            </Button>
          </>
        }
      >
        <Datalist
          data={products}
          renderTableHeader={() => (
            <Datalist.Row display="grid" gridTemplateColumns="1fr 0.5fr 0.5fr 0.5fr">
              <Datalist.HeaderCell label="name" />
              <Datalist.HeaderCell label="price" />
              <Datalist.HeaderCell label="quantity" />
              <Datalist.HeaderCell label="total" />
            </Datalist.Row>
          )}
          renderTableRow={({ Product, price, quantity, totalPrice }) => (
            <Datalist.Row
              display="grid"
              gridTemplateColumns={{
                _: 'repeat(2, 1fr)',
                DESKTOP: '1fr 0.5fr 0.5fr 0.5fr',
              }}
            >
              <Datalist.Cell label="name">{Product.name}</Datalist.Cell>
              <Datalist.Cell label="price">${price}</Datalist.Cell>
              <Datalist.Cell label="quantity">{quantity}</Datalist.Cell>
              <Datalist.Cell label="total">${totalPrice}</Datalist.Cell>
            </Datalist.Row>
          )}
        />
        <Box mt="2rem" display="flex" justifyContent="center">
          <Text fontSize={fontSizes.l} color={COLOR.brand}>
            Total price: ${priceOfAllProducts}
          </Text>
        </Box>
      </ConfirmationDialog>
    </>
  )
}
